import { enCa } from './en-ca';
import { frCa } from './fr-ca';

/**
 * add/remove language files here
 *
 * if there is only 1 loaded, the language toggle will not be available with the stock header
 */
export const languages: LanguageDef = {
	enCa: {label: 'English', dictionary: enCa },
	frCa: {label: 'Français', dictionary: frCa },
};

// stop editing below
export interface Dictionary {
	[key: string]: string;
}
export interface LanguageDef {[key: string]: {label: string, dictionary: Dictionary}; }

